module.exports = __webpack_public_path__ + "static/media/22ESCWA24.b0f32a62.jpg";